<tm-modal [title]="title" [message]="message" [okBtnLabel]="okBtnLabel" [cancelBtnLabel]="cancelBtnLabel"
  [panelClass]="panelClass" [modalConfig]="modalConfig"
  (afterConfirm)="afterConfirm.emit()" (afterCancel)="afterCancel.emit()">
  <tm-modal-header></tm-modal-header>
  <tm-modal-body>
    <p #tmModalBody [innerHTML]="safeMessage" style="white-space: pre-line;"></p>
  </tm-modal-body>
  <tm-modal-footer></tm-modal-footer>
</tm-modal>
